import React, { ReactNode, FC, useContext } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';
import ColorSchemeContext from '../../colorScheme/ColorSchemeContext';
import { StyledTitle } from './Promo2.styles';

export interface Promo2Props extends SCP<'h2'> {
  children?: ReactNode;
}

/**
 * @since 0.28.1
 */
const Promo2: FC<Promo2Props> = (props) => {
  const { scheme } = useContext(ColorSchemeContext);

  return (
    <StyledTitle darkened={scheme === COLOR_SCHEMES.DARK} {...props} />
  );
};

/** @component */
export default Promo2;
